<template>
  <div class="container is-fluid is-back-denim" style="min-height: 75px"></div>
</template>

<script setup></script>

<style></style>
